import { AxiosResponse } from "axios";

import {
  IRagAvailableMeasurement,
  IRagConfig,
  IRagConfigListItem,
} from "../@types/Rag";
import { api } from "./api";

export const ragConfigService = {
  async getByHospital(
    hospitalGroupId: number
  ): Promise<AxiosResponse<IRagConfigListItem[]>> {
    const url = `/Portal/RagConfigs/ByHospital/${hospitalGroupId}`;
    return api.get<IRagConfigListItem[]>(url);
  },

  /**
   * EN-5123: the measurements that can be RAG-banded on `wards` — the UNION across them, so a
   * measurement only one ward collects is offered (patients whose wards don't collect it show "-").
   * Omit `wards` to get the caller's own wards, which is what the patient list needs.
   */
  async getAvailableMeasurements(
    wards?: number[]
  ): Promise<AxiosResponse<IRagAvailableMeasurement[]>> {
    const url = "/Portal/RagConfigs/AvailableMeasurements";
    return api.post<IRagAvailableMeasurement[]>(url, { wards });
  },

  async getById(id: string): Promise<AxiosResponse<IRagConfig>> {
    const url = `/Portal/RagConfigs/${id}`;
    return api.get<IRagConfig>(url);
  },

  async create(
    hospitalGroupId: number,
    config: IRagConfig
  ): Promise<AxiosResponse<IRagConfig>> {
    const url = `/Portal/RagConfigs/ByHospital/${hospitalGroupId}`;
    return api.post<IRagConfig>(url, config);
  },

  async update(
    id: string,
    config: IRagConfig
  ): Promise<AxiosResponse<IRagConfig>> {
    const url = `/Portal/RagConfigs/${id}`;
    return api.put<IRagConfig>(url, config);
  },
};
